import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getMaintenanceTypeListSaga = createAction(
  "GET_MAINTENANCETYPE",
  ({ payload, params }: SagaActionParams<Type.MaintenanceTypeDto[]>) => ({
    payload,
    url: "/api/admin/maintenancetypes" + (params ? params : ""),
  })
);
export const getMaintenanceTypeDetailsSaga = createAction(
  "GET_MAINTENANCETYPE_DETAILS",
  ({ payload, id }: SagaActionParams<Type.MaintenanceTypeDetailDto>) => ({
    payload,
    url: "/api/admin/maintenancetypes/" + id,
  })
);
export const createMaintenanceTypeSaga = createAction(
  "CREATE_MAINTENANCETYPE",
  ({ payload, body }: SagaActionParams<Type.MaintenanceTypeDto>) => ({
    payload,
    url: "/api/admin/maintenancetypes",
    body,
  })
);
export const updateMaintenanceTypeSaga = createAction(
  "UPDATE_MAINTENANCETYPE",
  ({ payload, id, body }: SagaActionParams<Type.MaintenanceTypeDto>) => ({
    payload,
    url: "/api/admin/maintenancetypes/" + id,
    body,
  })
);
export const deleteMaintenanceTypeSaga = createAction(
  "DELETE_MAINTENANCETYPE",
  ({ payload, id }: SagaActionParams<Type.MaintenanceTypeDto>) => ({
    payload,
    url: "/api/admin/maintenancetypes/" + id,
  })
);

const maintenanceTypesSaga = [
  takeLatest<any>(
    getMaintenanceTypeListSaga.toString(),
    (payload: SagaGenericParams<Type.MaintenanceTypeDto[]>) =>
      getSaga<Type.MaintenanceTypeDto[]>(payload)
  ),
  takeLatest<any>(
    getMaintenanceTypeDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.MaintenanceTypeDetailDto>) =>
      getSaga<Type.MaintenanceTypeDetailDto>(payload)
  ),
  takeLatest<any>(
    createMaintenanceTypeSaga.toString(),
    (payload: SagaGenericParams<Type.MaintenanceTypeDto>) =>
      postSaga<Type.MaintenanceTypeDto>(payload)
  ),
  takeLatest<any>(
    updateMaintenanceTypeSaga.toString(),
    (payload: SagaGenericParams<Type.MaintenanceTypeDto>) =>
      putSaga<Type.MaintenanceTypeDto>(payload)
  ),
  takeLatest<any>(
    deleteMaintenanceTypeSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.MaintenanceTypeDto>(payload)
  ),
];

export default maintenanceTypesSaga;
